module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/business-category/business-category-create/business-category-create.component.css
// module id = ./src/app/components/business/business-category/business-category-create/business-category-create.component.css
// module chunks = main